module.exports = __webpack_public_path__ + "media/images/faces/male/27-70e8ada9635efa9131820f38f64ff18f.jpg";